import { createStore, applyMiddleware } from 'redux';
import GAMEOPTIONS from "./reducers"
import { composeWithDevTools } from 'redux-devtools-extension';
import { createSession } from 'redux-session';
const session = createSession({
  ns: 'booli',
  selectState ({GameOptions}) {
   return {
     token: GameOptions.unlocked_level
   };
  }
 });

const store = createStore(GAMEOPTIONS, composeWithDevTools(
  applyMiddleware(session)
));


export default store;



// WEBPACK FOOTER //
// ./src/store.js